module.exports = __webpack_public_path__ + "static/img/havkraftEU_2014_2020_rgb.f9324bf.png";